<template>
  <v-layout row align-end justify-space-between class="pa-2">

    <v-flex grow>
      <h2 class="all-caps subtle">Employee Contact:</h2>
      <v-text-field
        v-model="messageSubject"
        placeholder="Subject"
      ></v-text-field>
      <v-textarea
        v-model="messageBody"
        placeholder="Questions / Comments"
        hide-details
        box
      ></v-textarea>
    </v-flex>
    <v-flex shrink>
      <v-btn @click="sendMessage" color="success" :disabled="!messageBody">
        <v-icon left>
          forum
        </v-icon>
        Send
      </v-btn>
    </v-flex>

  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user'
    ]),
  },
  props: [
    'employee'
  ],
  data () {
    return {
      messageSubject: null,
      messageBody: null,
    }
  },
  methods: {
    discardMessage () {
      this.messageSubject = null
      this.messageBody = null
    },
    sendMessage () {
      this.$store.dispatch('messages/send',
        {
          senderId: this.user.id,
          recipientIds: [this.employee.id],
          subject: this.messageSubject,
          message: this.messageBody
        }
      ).then(res => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: 'Message sent!' })
      })
      .catch(res => {
        this.$store.dispatch('global/showSnackbarError', { message: 'Something went wrong with that message' })
      })
      .finally(res => {
        this.discardMessage()
      })
    },
  },
}
</script>
